import React, { memo } from "react";
import { EdgeProps } from "reactflow";
import {
  CustomEdge,
  CustomEdgeData,
  getOverviewWeightedClassName,
} from "../../components/GraphComponents";
import { DEFAULT_TELEMETRY_TYPE } from "../../components/MeasurementControlBar/MeasurementControlBar";
import { useOverviewPage } from "./OverviewPageContext";

const OverviewEdge: React.FC<EdgeProps<CustomEdgeData>> = (props) => {
  const { hoveredSet, selectedTelemetry, maxValues } = useOverviewPage();

  return (
    <CustomEdge
      {...props}
      hoveredSet={hoveredSet}
      telemetryType={selectedTelemetry ?? DEFAULT_TELEMETRY_TYPE}
      maxValues={maxValues}
      getWeightedClassFunc={getOverviewWeightedClassName}
    />
  );
};

export default memo(OverviewEdge);
